// (0, 0) is the API's unset-location sentinel, not a usable profile fallback.
export const parseMapLocation = (latitude, longitude) => {
  if (latitude == null || longitude == null ||
      String(latitude).trim() === "" || String(longitude).trim() === "") return null;
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng) ||
      Math.abs(lat) > 90 || Math.abs(lng) > 180 || (lat === 0 && lng === 0)) return null;
  return { lat, lng };
};
